<template>
  <div>
    <!-- Billing Dashboard -->
    <div class="mt-3">
      <InvoiceViewer
        :userId="user_id"
        :targetId="targetId"
      />
    </div>
  </div>
</template>

<script>
import InvoiceViewer from "@/components/Common/InvoiceViewer.vue";

export default {
  name: 'BillingToOrder',
  components: {
    InvoiceViewer
  },
  props: {
    targetId: {
      type: String,
      default: 0,
    },
    user_id: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style scoped>

</style>
